/* Mobile shortcut to the single native Dawn purchase form. */
if (!customElements.get('atelier-sticky')) {
  customElements.define('atelier-sticky', class extends HTMLElement {
    connectedCallback() {
      const root = document.getElementById(`MainProduct-${this.dataset.section}`);
      const buy = root?.querySelector('product-form');
      if (!root || !buy) return;
      this.link = this.querySelector('a');
      this.onClick = (event) => {
        event.preventDefault();
        const target = root.querySelector('variant-selects') || buy;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'center' });
        target.querySelector('input:checked, select, button:not([disabled])')?.focus({ preventScroll: true });
      };
      // A scroll update also covers jumps that skip over the entire purchase
      // form; an intersection-only observer would miss those jumps.
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.hidden = buy.getBoundingClientRect().bottom >= 0;
          this.frame = null;
        });
      };
      this.link?.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.link?.removeEventListener('click', this.onClick);
    }
  });
}
